import React, { useState } from 'react';
import '../styles/TaskList.css';
import useApiStable from "../utils/useApiStable";

function PersonGroupForm({ group, persons, onClose }) {
  const [name, setName] = useState(group?.name || '');
  const [description, setDescription] = useState(group?.description || '');
  const [selectedMembers, setSelectedMembers] = useState(
    group?.members ? group.members.map(m => m.id) : []
  );
  const [error, setError] = useState('');
  const api = useApiStable();

  const handleToggleMember = (personId) => {
    setSelectedMembers(prev => 
      prev.includes(personId)
        ? prev.filter(id => id !== personId)
        : [...prev, personId]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    
    if (!name.trim()) {
      setError('Bitte einen Gruppennamen eingeben.');
      return;
    }

    const payload = { 
      name: name.trim(), 
      description: description.trim() 
    };
    
    const request = group
      ? api.put(`/person-groups/${group.id}`, payload)
      : api.post(`/person-groups`, payload);
    
    request
      .then((savedGroup) => {
        // Mitglieder setzen
        return api.put(`/person-groups/${savedGroup.id}/members`, selectedMembers);
      })
      .then(() => onClose(true))
      .catch(err => {
        setError(err.message || 'Speichern fehlgeschlagen');
      });
  };

  return (
    <div className="taskform-card">
      <h3>{group ? 'Gruppe bearbeiten' : 'Neue Gruppe anlegen'}</h3>
      <form onSubmit={handleSubmit} noValidate>
        <div className="taskform-group">
          <label htmlFor="name">Gruppenname*</label>
          <input 
            id="name" 
            value={name} 
            onChange={e => setName(e.target.value)} 
            required 
          />
        </div>
        <div className="taskform-group">
          <label htmlFor="description">Beschreibung</label>
          <textarea
            id="description"
            value={description}
            onChange={e => setDescription(e.target.value)}
            rows="3"
          />
        </div>
        <div className="taskform-group">
          <label>Mitglieder</label>
          <div style={{ 
            maxHeight: '200px', 
            overflowY: 'auto', 
            border: '1px solid #ddd', 
            borderRadius: '4px',
            padding: '8px'
          }}>
            {persons.length === 0 ? (
              <p style={{ color: '#666', fontSize: '0.9em' }}>Keine Personen verfügbar</p>
            ) : (
              persons.map(person => (
                <label 
                  key={person.id} 
                  style={{ 
                    display: 'block', 
                    padding: '4px 0',
                    cursor: 'pointer'
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedMembers.includes(person.id)}
                    onChange={() => handleToggleMember(person.id)}
                    style={{ marginRight: '8px' }}
                  />
                  {person.name} ({person.email})
                </label>
              ))
            )}
          </div>
        </div>
        {error && (
          <div style={{ 
            color: '#c62828', 
            fontSize: '0.8rem', 
            marginTop: '8px', 
            marginBottom: '8px' 
          }}>
            {error}
          </div>
        )}
        <div className="taskform-actions">
          <button 
            className="taskform-save-btn" 
            type="submit" 
            disabled={!name.trim()}
          >
            Speichern
          </button>
          <button 
            className="taskform-cancel-btn" 
            type="button" 
            onClick={() => onClose(false)}
          >
            Abbrechen
          </button>
        </div>
      </form>
    </div>
  );
}

export default PersonGroupForm;
